import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import SimilarPlace from "../components/common/SimilarPlace";
import AboutPlace from "../components/layouts/Placedetail/AboutPlace";
import PlaceBreadCrumps from "../components/layouts/Placedetail/PlaceBreadCrumps";
import PlaceComment from "../components/layouts/Placedetail/PlaceComment";
import PlaceCostinfo from "../components/layouts/Placedetail/PlaceCostinfo";
import PlaceDetailCal from "../components/layouts/Placedetail/PlaceDetailCal";
// import PlaceDetailLoc from "../components/layouts/Placedetail/PlaceDetailLoc";
import PlaceFeature from "../components/layouts/Placedetail/PlaceFeature";
import PlaceLocation from "../components/layouts/Placedetail/PlaceLocation";
import PlaceRate from "../components/layouts/Placedetail/PlaceRate";
import PlaceReserve from "../components/layouts/Placedetail/PlaceReserve";
import PlaceRules from "../components/layouts/Placedetail/PlaceRules";
import PlaceSlider from "../components/layouts/Placedetail/PlaceSlider";
import Placetitle from "../components/layouts/Placedetail/Placetitle";
import ProfileDetail from "../components/layouts/Placedetail/ProfileDetail";
import useFetch from "../hooks/useAxios";

const PlaceDetail = () => {
  const [inforesidencedetail, setinforesidencedetail] = useState()
  const [selectedStartDay, setSelectedStartDay] = useState(null);

  const {code,slug}=useParams()
  const apiGetresidencedetailInfo = useFetch({
    method: "get",
    url: `api/residences/${code}/${slug}`,
    noHeader: true,
    trigger: true,
    argFunc:(res)=>setinforesidencedetail(res.data)
    
   
  });
  useEffect(() => {
    window.scrollTo(0,0)
  }, [code])
  
  return (
    <div className="mb-[140px]">
     {inforesidencedetail && <div className="container">
        <div className="grid gap-[32px] PlaceDetail__grid">
          <div>
            <div className="mb-[32px]">
              <ProfileDetail inforesidencedetail={inforesidencedetail} />
            </div>
            <PlaceCostinfo  setSelectedDay={setSelectedStartDay}
            selectedDay={selectedStartDay}
           inforesidencedetail={inforesidencedetail} />
          </div>
          <div>
          <PlaceBreadCrumps inforesidencedetail={inforesidencedetail}/>
           <div className="PlaceDetail__container">
           
            <Placetitle inforesidencedetail={inforesidencedetail}/>
            <hr/>
            <PlaceSlider  inforesidencedetail={inforesidencedetail} />
            <AboutPlace  inforesidencedetail={inforesidencedetail} />
            <hr />
            <p className="placedetail-description">
              {
              inforesidencedetail.description  
              }
            </p>
            <hr />
            <PlaceLocation inforesidencedetail={inforesidencedetail}/>
            <hr className="mt-[40px]"/>
            {inforesidencedetail.instant_reserve === 1 && <PlaceReserve />}
            <hr />
            <PlaceFeature inforesidencedetail={inforesidencedetail} />
            <hr />
            <PlaceRules inforesidencedetail={inforesidencedetail}/>
            <hr className="mb-[40px]" />
            <PlaceDetailCal
            
            setSelectedDay={setSelectedStartDay}
            inforesidencedetail={inforesidencedetail}
            selectedDay={selectedStartDay}
          
            /> 
           </div>
       
          </div>
        </div>

      <SimilarPlace />
       <div  className="grid gap-[32px] PlaceDetail__grid mt-[100px]">
       <PlaceRate  inforesidencedetail={inforesidencedetail}/>
       <PlaceComment inforesidencedetail={inforesidencedetail}/>
       </div>
      
      </div>
      }
    </div>
  );
};

export default PlaceDetail;
